






















import { Component, Vue, Prop, PropSync, Emit } from "vue-property-decorator";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { saudeAtendimentoService } from '@/service/cadastro/saude/atendimento/SaudeAtendimentoService';
import { RetornoMensagemModel } from '@/models/cadastros/saude/RetornoMensagemModel';

@Component({
  components: {
    GsModalDialog,
  },
})
export default class ModalAprovarRecusarValorAdicional extends Vue {

  @Prop({ default: "RECUSA" })
  tipo!: string;

  @Prop()
  readonly idAtendimento!: number;

  @PropSync("exibeModal", { required: true })
  exibeModalSynced!: boolean;

  texto = "";

  get isAprovacao(): boolean {
    return this.tipo == "APROVAR";
  }
  
  get isRecusa(): boolean {
    return this.tipo == "RECUSAR";
  }

  cancelar() {
    this.exibeModalSynced = false;
  }

  aprovar() {
    saudeAtendimentoService.aprovarValorAdicional(this.idAtendimento, "Valor adicional aprovado pela central")
    .then((retornoMensagem: RetornoMensagemModel) => {
      this.exibirMessageDialog("Sucesso", "Valor adicional aprovado.", true);
    })
    .catch((err: Error) => {
      this.exibirMessageDialog("Erro", err.message, false);
    })
    .finally(()=> {
      this.exibeModalSynced = false;
    });
  }

  recusar() {
    saudeAtendimentoService.recusarValorAdicional(this.idAtendimento, this.texto)
    .then((retornoMensagem: RetornoMensagemModel) => {
      this.exibirMessageDialog("Sucesso", "Valor adicional recusado.", true);
    })
    .catch((err: Error) => {
      this.exibirMessageDialog("Erro", err.message, false);
    })
    .finally(()=> {
      this.exibeModalSynced = false;
    });
  }  

  @Emit("messageDialog")
  exibirMessageDialog(titulo: string, mensagem: string, sucesso: boolean) {
    return {
      titulo,
      mensagem,
      sucesso,
    };
  }
}
